'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UrlControl = function () {
  function UrlControl(element, args) {
    var _this = this;

    _classCallCheck(this, UrlControl);

    var div = document.createElement('div');
    this.input = document.createElement('input');
    this.input.id = window.PRIM.getUUID();
    this.input.value = args.value ? args.value : '';
    this.input.type = 'url';
    this.input.autocapitalize = 'off';
    this.input.autocorrect = 'off';
    this.input.spellcheck = 'false';
    this.input.disabled = args.readonly ? 'disabled' : '';
    this.input.onchange = args.onchange;
    this.label = document.createElement('label');
    this.label.innerHTML = args.label;
    this.label.htmlFor = this.input.id;

    var onclick = function onclick() {
      if (_this.input.value) {
        var parsedUrl = _this.input.value.trim();

        if (parsedUrl) {
          open(parsedUrl);
        }
      }
    };

    var button = document.createElement('button');
    button.className = 'icon';
    button.innerHTML = '\uE06D';
    button.onclick = onclick;

    var fragment = document.createDocumentFragment();
    fragment.appendChild(div);
    div.appendChild(this.label);
    div.appendChild(this.input);
    div.appendChild(button);

    element.appendChild(fragment);
  }

  _createClass(UrlControl, [{
    key: 'setLabel',
    value: function setLabel(text) {
      this.label.innerHTML = text;
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      return this.input.value ? this.input.value : null;
    }
  }, {
    key: 'setValue',
    value: function setValue(value) {
      this.input.value = value;
    }
  }]);

  return UrlControl;
}();

exports.default = UrlControl;


//////////////////
// WEBPACK FOOTER
// ./js/lib/ui/UrlControl.js
// module id = 64
// module chunks = 0